import BottomNav from "@/components/BottomNav";
import { useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";

export default function AppShell({ children }) {
  const location = useLocation();
  const scrollRef = useRef(null);

  // Scroll to top on route change
  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen w-full flex justify-center" data-testid="app-root">
      <div
        ref={scrollRef}
        data-testid="app-frame"
        className="relative w-full max-w-md min-h-screen bg-[#f9f5ef] shadow-[0_30px_80px_-30px_rgba(46,40,32,0.35)] overflow-y-auto overflow-x-hidden"
        style={{ minHeight: "100dvh" }}
      >
        <div key={location.pathname} className="lsw-fade-up pb-32">
          {children}
        </div>
        <BottomNav />
      </div>
    </div>
  );
}
